/* eslint-disable eqeqeq */
/* eslint-disable indent */
import React from 'react'
import { Card, Form, Row, Col, Button } from 'react-bootstrap'
import { NumericFormat } from 'react-number-format'
import { skillArr, translations } from '../services/arrays'
import { getTranslation } from '../services/translations'

const PlayerSkillsCard = ({
  playerSkills,
  oldPlayerSkills,
  calculateSkillChange,
  handleSkillChange,
  updatePlayer,
  language,
  lang,
}) => {
  const t = key => getTranslation(lang, key)

  return (
    <Card
      className="w-100"
      style={{
        backgroundColor: '#23272A',
        color: '#FFFFFF',
        borderColor: '#1E2124',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('skills')}
      </Card.Header>
      <Card.Body style={{ padding: '8px 12px' }}>
        <Form>
          {skillArr.map(skill => (
            <Form.Group
              as={Row}
              controlId={`form${skill}`}
              key={skill}
              className="mb-1"
              style={{ flexWrap: 'nowrap' }}
            >
              <Form.Label
                column
                style={{
                  flex: '1 1 auto',
                  fontSize: '0.8rem',
                  padding: '2px 8px',
                  whiteSpace: 'nowrap',
                }}
              >
                {translations[skill][language]
                  ? translations[skill][language]
                  : skill.replace('Skill', '')}
              </Form.Label>
              <Col
                style={{
                  flex: '0 0 auto',
                  width: 'auto',
                  padding: '0 4px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                {oldPlayerSkills && oldPlayerSkills[skill] !== undefined && (
                  <span
                    style={{
                      color:
                        playerSkills[skill] > oldPlayerSkills[skill]
                          ? 'green'
                          : playerSkills[skill] < oldPlayerSkills[skill]
                          ? '#ff7575'
                          : 'transparent',
                      fontSize: '0.75rem',
                      minWidth: '48px',
                      textAlign: 'right',
                    }}
                  >
                    {calculateSkillChange(
                      playerSkills[skill] != null
                        ? playerSkills[skill].toFixed(3)
                        : '',
                      oldPlayerSkills[skill] != null
                        ? oldPlayerSkills[skill].toFixed(3)
                        : ''
                    )}
                  </span>
                )}
              </Col>
              <Col
                style={{
                  flex: '0 0 auto',
                  width: 'auto',
                  padding: '0 8px 0 4px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <NumericFormat
                  value={
                    Number.isFinite(playerSkills[skill])
                      ? playerSkills[skill]
                      : ''
                  }
                  onValueChange={values => {
                    const { floatValue } = values
                    handleSkillChange({
                      target: { name: skill, value: floatValue },
                    })
                  }}
                  decimalSeparator=","
                  thousandSeparator="."
                  allowNegative={false}
                  decimalScale={3}
                  fixedDecimalScale={true}
                  className="form-control form-control-sm"
                  style={{
                    backgroundColor: '#1E2124',
                    color: '#FFFFFF',
                    width: '80px',
                    padding: '2px 6px',
                    fontSize: '0.8rem',
                  }}
                />
              </Col>
            </Form.Group>
          ))}
          <div className="d-flex justify-content-end mt-2">
            <Button
              variant="primary"
              onClick={updatePlayer}
              size="sm"
              style={{
                backgroundColor: '#1E2124',
                borderColor: '#1E2124',
              }}
            >
              {t('updateSublevels')}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  )
}

export default PlayerSkillsCard
